
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
@Component
export default class MulReportHeader extends Vue {
  @Prop({ default: () => {} }) readonly dataFrom!: any;
  @Prop({ default: false }) readonly isRange!: boolean;
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: true }) readonly excelShow!: boolean;
  @Prop({ default: () => null }) readonly toPdf!: Function;
  @Prop({ default: () => null }) readonly toExe!: Function;
  @Prop({ default: false }) readonly excelDisabled!: boolean;
  select = {
    show_list: [],
  };
  updateSelect() {
    this.dataFrom.app_ids = [];
    this.select.show_list = this.getAppList();
  }
  getAppList() {
    return (this as any).app_list.filter((el: any) =>
      this.dataFrom.platids.includes(el.platform)
    );
  }
  handleClick() {
    this.$emit("search", {
      plat_list: (this as any).plat_list,
      app_list: (this as any).app_list,
    });
  }
  toExcel() {
    if (this.toExe) {
      this.toExe();
    } else {
      (this as any).eleToExcel();
    }
  }
  initFunc() {
    this.handleClick();
  }
  created() {
    this.initFunc();
  }
}
